module.exports = __webpack_public_path__ + "static/media/craft-07.46f6cd2d.svg";